import { NSARouterMakerResult } from "namirasoft-account-react";
import { NSSpace, NSSpaceSizeType } from "namirasoft-site-react";
import { Component } from "react";
import { useParams } from "react-router-dom";
import ChatContent from "../components/ChatContent";
import { InferenceEntities } from "../InferenceEntities";
import { InferenceInfo } from "../InferenceInfo";
import { InferenceLayout } from '../InferenceLayout';
import { InferenceRouterProps } from "../InferenceRouterProps";

interface ChatViewPageInnerProps extends NSARouterMakerResult, InferenceRouterProps
{
    chat_id: string;
}

class ChatViewPageInner extends Component<ChatViewPageInnerProps>
{
    override render()
    {
        return (
            <InferenceLayout
                {...this.props}
                action={{ description: InferenceInfo.chat_view }}
                pages={{
                    entity: InferenceEntities.chat(this.props),
                    view: {}
                }}
            >
                <>
                    <NSSpace size={NSSpaceSizeType.SMALL} />
                    <ChatContent
                        {...this.props}
                        chat_id={this.props.chat_id}
                        showHeader={true}
                        showChatBar={true}
                    />
                </>
            </InferenceLayout>
        );
    }
}

interface ChatViewPageProps extends NSARouterMakerResult, InferenceRouterProps { }

function ChatViewPage(props: ChatViewPageProps)
{
    let params = useParams();
    let chat_id = params["id"] ?? "";
    return <ChatViewPageInner {...props} chat_id={chat_id} />;
}

export default ChatViewPage;